var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    id: "svg208",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs212"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 11.983203,3.0430786 C 11.987112,2.8662774 11.935891,2.6926729 11.836538,2.5463735 11.737183,2.4000742 11.594677,2.2883606 11.428861,2.2267723 11.263113,2.1651771 11.082299,2.15677 10.911553,2.2027063 10.740736,2.2486426 10.588579,2.3466469 10.476133,2.4830887 L 6.0161099,7.689198 1.5576351,2.4830884 C 1.4882594,2.3887028 1.4001897,2.3096598 1.2988546,2.2509021 1.1975196,2.1921444 1.085116,2.1549465 0.96874118,2.1416318 0.85235936,2.1283171 0.73451304,2.1391745 0.62252484,2.1735278 0.5105437,2.2078742 0.40682171,2.2649773 0.31792823,2.3412601 0.22902769,2.4175361 0.15692011,2.5113513 0.10595686,2.6168194 0.05500064,2.7222875 0.02637166,2.8371274 0.02185834,2.9542204 0.01734498,3.071243 0.03697551,3.1879838 0.07965847,3.29705 0.12234143,3.4061161 0.18708405,3.5052544 0.26983773,3.5881277 L 5.3696695,9.548674 c 0.079916,0.093647 0.1790544,0.1687744 0.2907961,0.2203151 0.1117418,0.05154 0.2333411,0.078226 0.3564189,0.078226 0.1230074,0 0.2446771,-0.026686 0.3564189,-0.078226 C 6.4850451,9.7174484 6.5842538,9.6423202 6.6641699,9.548674 L 11.768874,3.5881277 c 0.13378,-0.150538 0.209824,-0.3436745 0.214541,-0.5450491 z",
    fill: "#283856",
    id: "path206",
    style: {
      strokeWidth: 0.704107
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/ChevronDown.83de10f7a5c747eec18aff799bd9eecd.svg";
export { ForwardRef as ReactComponent };